export const SAVE_ACTIVITY_NAME = 'SAVE_ACTIVITY_NAME';
export const SAVE_ACTIVITY_NAME_SUCCESS = 'SAVE_ACTIVITY_NAME_SUCCESS';